import ContentBase from '../eyejack-web-core/src/content/core/content.base';
import { IAssetBase } from '../eyejack-web-core/src/core/loader/loader';

export default class ContentEmpty extends ContentBase {
  
  constructor() {
    super();
  }

  public override get assets(): IAssetBase[] {
    return [];
  }

  public override loadAssetComplete(asset: IAssetBase): void {
    //
  }

  public get isReady(): boolean {
    let ready = true;
    return ready;
  }

  public play(): void {
    //
  }
  
  public stop(): void {
    //
  }
}